import { useRef, useState, useEffect } from 'react';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { FormattedDate } from 'react-intl';
import { useReactToPrint } from 'react-to-print';
import styles from './PaymentPlanConfirmManualPageData.module.scss';
import PageLink from 'components/PageLink/PageLink';
import StepIndicator from 'components/StepIndicator/StepIndicator';
import { useForm } from 'react-hook-form';
import http from 'app/http';
import PrintPaymentPlanSummary from './components/PrintPaymentPlanConfirmManual';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import { getGTMVariables, getGTMVariablesPageView  } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const PaymentPlanConfirmManualPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const [printModel, setPrintModel] = useState<any>(undefined);
  const componentRef = useRef(null);
  const [eventTracked, setEventTracked] = useState<boolean>(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const onPrint = async () => {
    try {
      const response = await http.get(Model?.PrintPageUrl);
      if (response && response.data) {
        setPrintModel(response.data);
        handlePrint();
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

    useEffect(() => {
      if (eventTracked == false) {
        var tagManagerArgs: any;
        tagManagerArgs = {
          dataLayer: {
            event: 'checkout_step',
            checkout_name: 'Payment Plan Creation',
            checkout_step_number: '3',
            is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
          }
        }
        TagManager.dataLayer(tagManagerArgs);
        setEventTracked(true);
      }
    }, [eventTracked]);
  return (
    <div className={styles.wrapper_main}>
      <StepIndicator
        ActiveStep={Model?.ActiveWizardStep?.ActiveStep}
        TotalSteps={3}
        StepText={PageData?.StepText}
        OfText={PageData?.OfText}
      />
      <div className={styles.wrapper}>
        <div className="Section--secondaryBg">
          <div className={styles.container}>
            <div className="Page-container PageContainer--transparent">
              <section className="Section u-paddingHz u-paddingTz">
                <h1 className="u-marginTz title">
                  {' '}
                  <>{PageData?.PaymentPlanHeader}</>
                </h1>
                <RepaymentList
                  Heading={PageData?.YourRapaymentHeader}
                  Monthlylabel={Model?.NumberOfRegularPaymentsLabel}
                  NumberofMonth={Model?.NumberOfRegularPayments}
                  Mothlyamount={Model?.FormattedCurrencyRegularPayment}
                  Currencysymbol={Model?.FormattedCurrencySymbol}
                  Finallabel={PageData?.PaymentPlanItemLastPaymentValueLabel}
                  FinalAmount={Model?.FormattedCurrencyLastPayment}
                  Totaltext={PageData?.TotalPlanLabel}
                  Totalamount={
                      Model.FormattedCurrencyTotalPaymentAmount
                  }
                  PlanDueDateInfoText={PageData?.FirstPaymentDueDateDetails}
                  PlanDueDate={Model?.FormattedShortDateFirstPayment}
                  DiscountBalancelabel={PageData?.PaymentPlanItemDiscountedDebtBalanceLabel}
                  DiscountBalanceAmount={Model?.FormattedCurrencyOfferDiscountAmount}
                  BalanceLabel={PageData?.PaymentPlanItemDebtBalanceLabel}
                  BalanceAmount={Model?.FormattedCurrencyDebtBalance}
                  DiscountedDebtBalanceRaw={Model?.DiscountAmount}
                />
                <div className="Grid Grid--white Grid--gutterH u-marginBz">
                  {/* <div className="Grid-cell">
                  <div className="CreateRepaymentPlan-introText">
                    {PageData?.IsPdfDownloadVisible && (
                      <div
                        className="Text--medium u-marginTxsm"
                        dangerouslySetInnerHTML={{
                          __html: PageData?.PdfDownloadText,
                        }}
                      ></div>
                    )}
                  </div>
                  <div className="CreateRepaymentPlan-divider"></div>
                </div> */}
                  {/* <div className="Grid-cell u-lg-size1of1 u-textCenter">
                  <h3>
                    <>{PageData?.PaymentSummaryHeader}</>
                  </h3>
                </div> */}
                  {/* <div className="Grid-cell u-size1of1">
                  <div className="HeadingContentSplit">
                    <h3 className="Heading HeadingContentSplit-heading">
                      <>{PageData?.PaymentPlanItemsHeader}</>
                    </h3>
                    <div className="HeadingContentSplit-content">
                      {Model.IsPrintoutsEnabled && (
                        <div className={styles.printWrapper}>
                          <button
                            className="Link-icon Link-print Print--receipt"
                            onClick={onPrint}
                          >
                            {PageData?.PrintButtonLabel}
                          </button>
                          {printModel && (
                            <div style={{ display: 'none' }}>
                              <PrintPaymentPlanSummary
                                ref={componentRef}
                                Model={printModel.Model}
                                PageData={printModel.PageData}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}
                  <div className="Grid-cell u-lg-size1of1 u-PaddingHz">
                    <h3 className={styles.manual__heading}>
                      <>{PageData?.ManualPlanHeader}</>
                    </h3>
                    <div className={styles.manual_body}>
                      <p>{PageData?.ManualPlanBody}</p>
                    </div>
                    <div className={styles.logowrapper}>
                      <div className={styles.logotext}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            '/images/icons/SecurePayment.svg'
                          }
                          width="28"
                        />
                        {PageData?.SecurePaymentLabel}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="Grid">
                  <div className="Grid-cell ">
                    <div className="CreateRepaymentPlan__ctaWrapper button-alignment">
                      <PageLink
                        url={Model.BackPageUrl}
                        text={PageData.BackButtonLabel}
                        className="Button Button--gray CreateRepaymentPlan__cancelBtn"
                      />
                      <PageLink
                        url={Model.ConfirmPageUrl}
                        text={PageData?.ConfirmButtonLabel}
                        className="Button CreateRepaymentPlan__confirmBtn"
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PaymentPlanConfirmManualPageData;
